<template>
    <Modal size="md" @close="$emit('close')">
        <template #header>
            <div class="text-gray-600">
                <span>
                    {{ status ? 'Edit' : 'Add' }}
                </span>

                status
            </div>
        </template>

        <template #body>
            <div class="p-6">
                <div class="flex flex-col">
                    <TextInput
                        v-model="state.status"
                        placeholder="Enter status"
                        label="Status"
                        :error="getError('status')"
                    />
                </div>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-between border-t border-gray-200 p-6">
                <AtomicButton color="white" size="md" @click="$emit('close')">
                    Close
                </AtomicButton>

                <AtomicButton
                    color="yellow"
                    size="md"
                    :disabled="state.status === ''"
                    @click="submit"
                >
                    Submit
                </AtomicButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts" setup>
import useVuelidate from '@vuelidate/core';
import { maxLength, required } from '@vuelidate/validators';
import IInputErrors from '@/types/Atomic/IInputErrors';

const props = defineProps({
    status: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['close', 'submit']);
const errors = ref<IInputErrors>({});

const state = reactive({
    status: props.status,
});

const rules = {
    status: {
        required,
        maxLength: maxLength(255),
    },
};

const v$ = useVuelidate(rules, state);

const submit = () => {
    v$.value.$touch();
    if (v$.value.$error) {
        return;
    } else {
        emit('submit', state.status);
    }
};

const getError = (field: string) => {
    return v$.value[field]?.$errors[0]?.$message || errors.value?.[field] || '';
};
</script>
